import {
    Platform
} from "react-native";
import type {
    PointerType
} from "../../types/theme";

type InputTextStyleBase = {
    lineHeight?: number;
    fontSize?: number;
};

export const INPUT_TOUCH_MIN_FONT_SIZE = 16;

export const getTouchSafeTextStyle = <T extends InputTextStyleBase>({
    pointerType,
    typography,
    textStyle
}: {
    typography: NCoreUIKit.Typography;
    pointerType: PointerType;
    textStyle: T;
}): T => {
    if(Platform.OS !== "web" || pointerType !== "coarse" || (textStyle.fontSize ?? 0) >= INPUT_TOUCH_MIN_FONT_SIZE) {
        return textStyle;
    }

    return {
        ...textStyle,
        lineHeight: Math.max(textStyle.lineHeight ?? 0, typography.bodyLargeSize.lineHeight ?? 0),
        fontSize: INPUT_TOUCH_MIN_FONT_SIZE
    };
};

export const getInputTextStyle = <T extends InputTextStyleBase>({
    pointerType,
    typography,
    textStyle
}: {
    typography: NCoreUIKit.Typography;
    pointerType: PointerType;
    textStyle: T;
}): T => {
    const style = getTouchSafeTextStyle({
        pointerType,
        typography,
        textStyle
    });

    if(Platform.OS !== "web") {
        return style;
    }

    return {
        ...style,
        outlineStyle: "solid",
        outlineWidth: 0
    };
};
